const deviceListTemplate = require("./device_list.html.slim");
declare var angular;

export class TwoFactorDeviceList {
  static $inject = ['$rootScope', '$scope', 'users', 'moment'];

  twoFactorEnabled: boolean;
  twoFactorInfo: any;
  deviceList: any[];
  currentDevice: boolean;
  error: string;
  list: string;
  step: string;
  title: string;
  selectedDevice: any;
  loading: string;
  errorMaxRetries: string = '';
  code: any;

  constructor(
    public $rootScope,
    public $scope,
    public users,
    private moment
  ) {}

  authorizeDevice() {
    this.step = "authorizeDevice";
    this.title = "Authorize Device";
    this.$scope.manageDevicesDialog.show();
  }

  confirmAuthorizeDevice(code) {
    this.users.confirmTwoFactorAuth(code, true)
      .then((resp) => {
        this.title = '';
        this.step = "authorizeDeviceSuccess";
        this.error = '';
        this.$rootScope.$emit("update_tfa_dashboard");
      })
      .catch((error) => {
        this.error = error.data.message;
      });
  }

  requestCode() {
    if(this.errorMaxRetries === ''){
      this.loading = 'loading';
      this.users.requestTwoFactorAuth()
        .then((resp) => {
          this.loading = 'loaded';
          this.error = '';
        })
        .catch((error) => {
          this.loading = '';
          if (error.data.error_code && error.data.error_code === 'max_retries_reached') {
            this.errorMaxRetries = error.data.message;
            this.resetSendError();
          }else{
            this.error = error.data.message;
          }
        });
    }
  }

  resetSendError() {
    setTimeout(() => { 
      this.errorMaxRetries = '';
    }, 120000);
  }
  
  removeDevice(id) {
    this.step = "removeDevice";
    this.title = "Remove Device";
    this.$scope.manageDevicesDialog.show();
    this.selectedDevice = id;
  }

  confirmRemoveDevice() {
    this.users.revokeDeviceAccess(this.selectedDevice)
      .then(() => {
        this.$rootScope.$emit("update_tfa_dashboard");
         this.$scope.manageDevicesDialog.hide();
      })
      .catch((error) => {
        this.error = error.data.message;
      });
  }

  changeStep(step) {
    if (this.twoFactorInfo.method === 'sms' && step === 'authorizeDeviceConfirm') {
      this.requestCode(); 
    };
    this.step = step;
  }

  createDate(date) {
    return this.moment(date, 'YYYY-MM-DD').format('MM-YYYY');
  }

  expiryDate(start, end) {
    if (this.moment(end).diff(this.moment(start), 'days') > 30) {
      return this.moment(end).diff(this.moment(start), 'months') + ' months';
    } else {
      return this.moment(end).diff(this.moment(start), 'days') + ' days';
    }
  }
}

angular.module("wbComponents").directive("twoFactorAuthDeviceList", function() {
  return {
    restrict: "E",
    templateUrl: deviceListTemplate,
    controller: TwoFactorDeviceList,
    controllerAs: 'list',
    bindToController: true,
    scope: {
      twoFactorEnabled: '=',
      twoFactorInfo: '=',
      deviceList: '=',
      currentDevice: '='
    }
  };
});
